// import { epiweekToolTip } from './toolTipFormatterFlu'
import statesMap from '../../utils/stateMap'
import cbsasMap from '../../utils/cbsasMap'
import countyMap from '../../utils/countyMap'

const getLineChartOptions = (data, weeks, identifier, type) => {
  let displayName = ''
  let displayType = type

  switch (type) {
    case 'state':
      displayType = 'State'
      displayName = statesMap()[identifier]
      break
    case 'metro':
    case 'city':
      displayType = 'Metro'
      displayName = cbsasMap()[identifier]
      break
    case 'county':
      displayType = 'County'
      displayName = countyMap()[identifier]
      break
    default:
    // code block
  }
  return {
    chart: {
      type: 'line',
    },
    // title: {
    //   text: chartName,
    // },
    title: {
      text:
        'Seasonal Influenza Pattern for ' + displayType + ' : ' + displayName, //undefined,
    },

    xAxis: {
      title: {
        text: 'Epi Weeks',
      },
      categories: weeks,
    },
    tooltip: {
      crosshairs: true,
      shared: true,
      useHTML: true,
      padding: 0,
      formatter: null,
    },
    yAxis: {
      title: {
        text: 'Flu2',
      },
      min: 0,
    },

    credits: {
      enabled: false,
    },

    legend: {
      layout: 'horizontal',
      align: 'center',
      verticalAlign: 'bottom',
    },
    plotOptions: {
      line: {
        marker: {
          enabled: false,
        },
        dataLabels: {
          enabled: false,
        },
      },
    },
    series: data,

    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 500,
          },
          chartOptions: {
            legend: {
              layout: 'horizontal',
              align: 'center',
              verticalAlign: 'bottom',
            },
          },
        },
      ],
    },
  }
}

export default getLineChartOptions
